// @vendor
const React = require('react');
const PropTypes = require('prop-types');
import { FormattedText } from 'core/i18n';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';

const MessageBox = ({ boxColor, iconColor, contentText, titleText = null, buttonText = null, buttonAction = null }) => {
    return (
        <div className={`message-box ${boxColor}-box`}>
            <i className={`icons icons--icon-${iconColor}`} />
            <ConditionalToggling condition={titleText !== null}>
                <h6 className="font-heading6">{titleText}</h6>
            </ConditionalToggling>
            <p className="font-paragraph2">{contentText}</p>
            {buttonText && (
                <button className="form__button button" onClick={buttonAction}>
                    {buttonText}
                </button>
            )}
        </div>
    );
};

MessageBox.defaultProps = {
    boxColor: 'blue',
    iconColor: 'info-blue',
    contentText: <FormattedText value="identity-gdprVideoCallImportant" />,
    buttonText: null,
};

MessageBox.propTypes = {
    boxColor: PropTypes.oneOf(['red', 'blue', 'yellow', 'green']),
    iconColor: PropTypes.oneOf([
        'info-blue',
        'warning',
        'warning-yellow',
        'warning-2-center',
        'warning-2',
        'alert-red',
        'success',
        'success-green-old',
    ]),
};

export default MessageBox;
